import { SourceSystem } from "./BaseSourceSystem";
import React from "react";

export class BranchJourneySourceSystem extends SourceSystem {
  constructor(redirectUri: string, exitUri: string, navigate: INavigate) {
    super(redirectUri, exitUri, navigate);
    this.name = "branch-journey";
    this.photosRequired = true;
    this.errorUri = redirectUri || "/valuation-admin";
    this.stepCount = 9;
    this.photoGalleryContent = {
      stepNumber: 7
    };
    this.showEstimatedOfferPartExchange = true;
    this.showBranchValuationContent = true;
    this.showAssumptionQuestionsWithCondition = true;
    this.offerCardNoValuationSecondaryText = "Save and submit to continue.";
    this.initialOfferContent = {
      offerLabel: "Your estimated valuation",
      cta: "Save and submit valuation",
      subheaderTitle: "Your valuation",
      ctaMicro:
        "Next, the branch manager will give this a once over and lock in this valuation.",
      assumptionsCopy:
        "*Your personalised offer is subject to a full appraisal and is based on these assumptions.",
      renderImageUpload: false,
      stepNumber: 8,
      whatHappensNextContent: (
        <>
          <p>
            Once you’ve submitted your answers and photos, these will be sent to
            your Product Consultant to review.
          </p>
          <p>
            They will then give you a call to discuss your valuation and arrange
            a full branch appraisal.
          </p>
          <p>
            Your final price will then be agreed in consultation with you at
            your branch appraisal.
          </p>
        </>
      ),
      assumptionsContent: (
        <>
          <div className="ch-display--flex ch-justify-content--center">
            <span className="ch-fs--3 ch-text--center ch-color--ac-black">
              * This price is based on your answers and{" "}
              <button
                className="ch-btn ch-btn--link ch-pa--0 ch-fs--3"
                data-gtm-track="interaction"
                data-gtm-track-label="These assumptions from estimated"
                onClick={() => navigate("/assumptions")}
              >
                these assumptions
              </button>
              .
            </span>
          </div>
        </>
      )
    };
    this.quickValuation = false;
    this.showPrivacyStatement = true;
    this.analyticSearchParam = "BRANCH";
    this.analyticsJourney = "Branch";
    this.handleAssumptionsOnSubmit = () => {
      navigate("/estimated-offer");
    };
  }
}
